import { ILangInput } from './types';

interface ILang {
  hello: string;
  answers: {
    0: string;
    1: string;
    2: string;
    3: string;
    4: string;
    5: string;
  };
  btns: {
    back: string;
    next: string;
    continue: string;
  };
  question: {
    title: string;
  };
  greeting: string;
  descriptions: string;
  provideInfo: string;
  enterCred: string;
  search: string;
  classificationFilter: (name: string) => string;
  inputs: {
    name: ILangInput;
    email: ILangInput;
    phone: ILangInput;
    payrollId: ILangInput;
  };
  toUnderstand: string;
  privacyPol: string;
  welcome: string;
  anonymous_respond: (num: number) => string;
  respond: (num: number) => string;
  thankForResp: string;
  goToAss: string;
  goodWork: (name: string) => string;
  completed: string;
  thanksForTime: string;
  privilegedAndConfidential: string;
  privilegedAndConfidentialTitle: string;
  understandBtnText: string;
  anonymousQuestion: string;
}

export const LangAssessments: {
  en: ILang;
  es: ILang;
  fr: ILang;
  he: ILang;
  hmn: ILang;
} = {
  en: {
    anonymousQuestion: 'Anonymous question',
    understandBtnText: 'I understand',
    privilegedAndConfidentialTitle: 'Your survey feedback is confidential and protected',
    privilegedAndConfidential: 'Privileged and Confidential: this survey constitutes quality assurance and performance ' +
        'improvement work-product as defined and protected by 42 CFR § 483.75(o)(3), 42 U.S.C. § 1395i-3(b)(1)(B), and ' +
        '42 U.S.C. § 1396r(b)(1)(B). This survey form, its content, and all other documents, notes, compilations, studies, ' +
        'findings, plans, recommendations, evaluations, opinions, minutes, reports, and records are highly confidential, ' +
        'privileged and protected by the federal quality assurance privilege and applicable state laws, and shall not be' +
        ' subject to discovery, subpoena, or other means of legal compulsion for their release to any person or entity or ' +
        'be admissible into evidence in any civil action, arbitration, or any other judicial or administrative proceeding.' +
        ' Nor shall testimony relating thereto be compelled, or admitted or introduced into evidence, or in any action ' +
        'of any kind in any court or before any administrative body, agency, or person for any purpose whatsoever. ' +
        'Any and all other legal privileges, immunities, and/or defenses are expressly reserved and preserved. ' +
        '\nI acknowledge ' +
        'I provided my honest feedback and did not fabricate feedback on anyone’s behalf. I agree to enable temporary ' +
        'tracking that ensures the integrity of this survey.',
    thanksForTime:
      'Thanks for your time. Understanding how employees feel about their workplace culture is critical to knowing how to improve the culture.',
    completed: 'You completed the assessments!',
    goodWork: (name) => `Good work ${name}!`,
    goToAss: 'Go to assessment list',
    thankForResp: 'This section is complete!',
    anonymous_respond: (n) => `Your survey feedback is anonymous, confidential, and legally protected.`,
    respond: (n) => `Please respond to this survey request:`,
    welcome: 'Welcome',
    toUnderstand:
      'To understand the purpose of this survey asking for your identity and understand your data privacy, please visit',
    privacyPol: 'OrgVitals Privacy Policy',
    hello: 'Hello',
    answers: {
      0: 'Pass',
      1: 'Strongly Disagree',
      2: 'Somewhat Disagree',
      3: 'Neither Agree nor Disagree',
      4: 'Somewhat Agree',
      5: 'Strongly Agree',
    },
    btns: {
      back: 'Back',
      next: 'Next',
      continue: 'Continue',
    },
    question: {
      title: 'Question',
    },
    greeting: 'Hello! Welcome to OrgVitals.',
    descriptions:
      'OrgVitals aggregates employee responses to understand organizational culture and tracks sentiment in areas like stress, connectedness and capacity.',
    provideInfo:
      'Information you provide will help generate meaningful conversations to improve the work culture.',
    inputs: {
      name: {
        placeholder: 'Start typing your name',
        label: '',
        subText: '',
        errorText: '',
      },
      email: {
        placeholder: 'Email',
        label: '',
        subText: '',
        errorText: '',
      },
      phone: {
        placeholder: 'Phone',
        label: '',
        subText: '',
        errorText: '',
      },
      payrollId: {
        placeholder: 'ID',
        label: '',
        subText: '',
        errorText: '',
      },
    },
    enterCred: 'Please enter your credential. If you see a dropdown, you may pick the credential you prefer to use.',
    search: 'Search',
    classificationFilter: (name) => `Find your ${name}:`,
  },
  es: {
    anonymousQuestion: 'Pregunta anónima',
    understandBtnText: 'Entiendo',
    privilegedAndConfidentialTitle: 'Los comentarios de su encuesta son confidenciales y están protegidos',
    privilegedAndConfidential: 'Privilegiado y confidencial: esta encuesta constituye un producto de trabajo de ' +
        'garantía de calidad y mejora del desempeño según lo define y protege 42 CFR § 483.75(o)(3), 42 U.S.C.' +
        ' § 1395i-3(b)(1)(B), y 42 U.S.C. § 1396r(b)(1)(B). Este formulario de encuesta, su contenido y todos' +
        ' los demás documentos, notas, compilaciones, estudios, hallazgos, planes, recomendaciones, evaluaciones,' +
        ' opiniones, actas, informes y registros son altamente confidenciales, privilegiados y protegidos por el ' +
        'privilegio federal de garantía de calidad y el estado aplicable leyes, y no estarán sujetos a descubrimiento,' +
        ' citación u otros medios de coerción legal para su liberación a ninguna persona o entidad ni serán admisibles' +
        ' como prueba en ninguna acción civil, arbitraje o cualquier otro procedimiento judicial o administrativo.' +
        ' Tampoco se obligará, ni se admitirá ni se introducirá como prueba el testimonio relacionado con el mismo, ' +
        'ni en ninguna acción de ningún tipo en ningún tribunal o ante ningún organismo administrativo, agencia o ' +
        'persona para ningún propósito. Todos y cada uno de los demás privilegios, inmunidades y/o defensas legales ' +
        'están expresamente reservados y preservados. \nReconozco que proporcioné mis comentarios honestos y que no los ' +
        'inventé en nombre de nadie. Acepto habilitar un seguimiento temporal que garantice la integridad de esta encuesta.',
    thanksForTime:
      'Gracias por tu tiempo. Comprender cómo se sienten los empleados sobre su cultura en el lugar de trabajo es fundamental para saber cómo mejorar la cultura.',
    completed: '¡Has completado las evaluaciones!',
    goodWork: (name) => `Buen trabajo ${name}!`,
    goToAss: 'Ir a la lista de evaluación',
    thankForResp: '¡Esta sección está completa!',
    anonymous_respond: (n) => `Los comentarios de su encuesta son anónimos, confidenciales y están protegidos legalmente.`,
    respond: (n) => `Responda a esta solicitud de encuesta:`,
    welcome: 'Bienvenido',
    toUnderstand:
      'Para comprender el propósito de esta encuesta solicitando su identidad y comprenda su privacidad de datos, visite la',
    privacyPol: 'Política de privacidad de OrgVitals',
    hello: 'Hola',
    answers: {
      0: 'Aprobar',
      1: 'Totalmente en desacuerdo',
      2: 'Algo en desacuerdo',
      3: 'Ni de acuerdo ni en desacuerdo',
      4: 'Algo de acuerdo',
      5: 'Totalmente de acuerdo',
    },
    btns: {
      back: 'Atrás',
      next: 'Próximo',
      continue: 'Continuar',
    },

    question: {
      title: 'Pregunta',
    },
    greeting: '¡Hola! Bienvenido a OrgVitals.',
    descriptions:
      'OrgVitals agrega las respuestas de los empleados para comprender la cultura organizacional y las pistas del sentimiento en áreas como el estrés, la conexión y la capacidad.',
    provideInfo:
      'La información que proporciona ayudará a generar conversaciones significativas para mejorar la cultura laboral.',
    inputs: {
      name: {
        placeholder:
          'Empieza a escribir tu nombre',
        label: '',
        subText: '',
        errorText: '',
      },
      email: {
        placeholder: 'Email',
        label: '',
        subText: '',
        errorText: '',
      },
      phone: {
        placeholder: 'Teléfono',
        label: '',
        subText: '',
        errorText: '',
      },
      payrollId: {
        placeholder: 'ID',
        label: '',
        subText: '',
        errorText: '',
      },
    },
    enterCred: 'Por favor ingrese su credencial. Si ve un menú desplegable, puede elegir la credencial que prefiere usar.',
    search: 'Búsqueda',
    classificationFilter: (name) => `Encuentra tu ${name}:`,
  },
  fr: {
    anonymousQuestion: 'Question anonyme',
    understandBtnText: 'Je comprends',
    privilegedAndConfidentialTitle: 'Les commentaires de votre enquête sont confidentiels et protégés',
    privilegedAndConfidential: 'Privilégié et confidentiel: cette enquête constitue un produit de travail ' +
        'd\'assurance qualité et d\'amélioration des performances tel que défini et protégé par 42 CFR § 483.75(o)(3), ' +
        '42 U.S.C. § 1395i-3(b)(1)(B) et 42 U.S.C. § 1396r(b)(1)(B). Ce formulaire d\'enquête, son contenu et tous les ' +
        'autres documents, notes, compilations, études, conclusions, plans, recommandations, évaluations, opinions, ' +
        'procès-verbaux, rapports et dossiers sont hautement confidentiels, privilégiés et protégés par le privilège' +
        ' fédéral d\'assurance qualité et par l\'État applicable lois, et ne doivent pas faire l\'objet d\'une enquête ' +
        'préalable, d\'une assignation à comparaître ou d\'autres moyens de contrainte légale pour leur libération à ' +
        'toute personne ou entité ou être admissibles comme preuve dans toute action civile, arbitrage ou toute autre ' +
        'procédure judiciaire ou administrative. Les témoignages s\'y rapportant ne seront pas non plus forcés, admis ' +
        'ou introduits en preuve, ni dans aucune action de quelque nature que ce soit devant un tribunal ou devant un' +
        ' organe administratif, une agence ou une personne à quelque fin que ce soit. Tous les autres privilèges, ' +
        'immunités et/ou défenses juridiques sont expressément réservés et préservés. \nJe reconnais que j’ai fourni mes ' +
        'commentaires honnêtes et que je n’ai fabriqué aucun commentaire au nom de qui que ce soit. J\'accepte d\'activer ' +
        'le suivi temporaire qui garantit l\'intégrité de cette enquête.',
    thanksForTime:
      'Merci pour votre temps. Comprendre comment les employés se sentent à propos de leur culture sur le lieu de travail sont essentiels à savoir comment améliorer la culture.',
    completed: 'Vous avez terminé les évaluations!',
    goodWork: (name) => `Bon travail ${name}!`,
    goToAss: `Aller à la liste d'évaluation`,
    thankForResp: `Cette section est complète!`,
    anonymous_respond: (n) => `Vos réponses au sondage sont anonymes, confidentielles et protégées juridiquement.`,
    respond: (n) => `Veuillez répondre à cette demande d'enquête:`,
    welcome: 'Bienvenue',
    toUnderstand:
      'Pour comprendre le but de cette enquête demandant votre identité et comprendre votre confidentialité de données, veuillez visiter la ',
    privacyPol: 'Politique de confidentialité des OrgVitals',
    hello: 'Bonjour',
    answers: {
      0: 'Passe',
      1: `Fortement en désaccord`,
      2: `Un peu en désaccord`,
      3: `Ni d'accord ni en désaccord`,
      4: `Plutôt d'accord`,
      5: `Tout à fait d'accord`,
    },
    btns: {
      back: 'Retour',
      next: 'Suivant',
      continue: 'Continuez',
    },
    question: {
      title: 'Question',
    },
    greeting: 'Salut! Bienvenue dans les OrgVitals.',
    descriptions:
      'OrgVitals abrite les réponses des employés pour comprendre la culture organisationnelle et les pistes de sentiment dans des domaines tels que le stress, la connectivité et la capacité.',
    provideInfo:
      'Les informations que vous fournissez aideront à générer des conversations significatives pour améliorer la culture de travail.',
    inputs: {
      name: {
        placeholder:
          'Commencez à taper votre nom',
        label: '',
        subText: '',
        errorText: '',
      },
      email: {
        placeholder: 'Email',
        label: '',
        subText: '',
        errorText: '',
      },
      phone: {
        placeholder: 'Téléphoner',
        label: '',
        subText: '',
        errorText: '',
      },
      payrollId: {
        placeholder: 'ID',
        label: '',
        subText: '',
        errorText: '',
      },
    },
    enterCred: 'Veuillez saisir votre identifiant. Si vous voyez une liste déroulante, vous pouvez choisir l\'identifiant que vous préférez utiliser.',
    search: 'Сhercher',
    classificationFilter: (name) => `Trouvez votre ${name}:`,
  },
  he: {
    anonymousQuestion: 'שאלה אנונימית',
    understandBtnText: 'אני מבין',
    privilegedAndConfidentialTitle: 'המשוב שלך על הסקר הוא סודי ומוגן',
    privilegedAndConfidential: 'מיוחס וסודי: סקר זה מהווה אבטחת איכות ושיפור ביצועים-מוצר עבודה כפי שהוגדר ומוגן ב-42 CFR § 483.75(o)(3), 42 U.S.C. § 1395i-3(b)(1)(B), ו-42 U.S.C. § 1396r(b)(1)(B). טופס סקר זה, תוכנו וכל שאר המסמכים, ההערות, הליקוטים, המחקרים, הממצאים, התוכניות, ההמלצות, הערכות, דעות, פרוטוקולים, דוחות ורישומים הם חסויים ביותר, מוגנים ומוגנים על ידי הרשאות אבטחת האיכות הפדרלית והמדינה הרלוונטית. חוקים, ולא יהיו כפופים לגילוי, הזמנה לדין או אמצעים אחרים של כפייה משפטית לשחרורם לכל אדם או ישות או יהיו קבילים לראיה בכל תביעה אזרחית, בוררות או כל הליך שיפוטי או מנהלי אחר. כמו כן, לא תיאלץ עדות המתייחסת לכך, או תתקבל או תוצג לראיה, או בכל פעולה מכל סוג שהוא בבית משפט או בפני כל גוף מנהלי, סוכנות או אדם לכל מטרה שהיא. כל יתר הפריבילגיות, החסינות ו/או ההגנות המשפטיות שמורות ונשמרות במפורש.\nאני מאשר שסיפקתי את המשוב הכנה שלי ולא בדהתי משוב מטעם אף אחד. אני מסכים לאפשר מעקב זמני המבטיח את שלמות הסקר הזה.',
    thanksForTime:
      'תודה על הזמן שלך. ההבנה כיצד עובדים מרגישים לגבי תרבות מקום העבודה שלהם היא קריטית לדעת כיצד לשפר את התרבות.',
    completed: 'השלמת את ההערכות!',
    goodWork: (name) => `עבודה טובה ${name}!`,
    goToAss: `עבור לרשימת הערכה`,
    thankForResp: `החלק הזה שלם!`,
    anonymous_respond: (n) => `משוב הסקר שלך אנונימי, סודי ומוגן על פי חוק.`,
    respond: (n) => `אנא השיב/י לבקשת סקר זה:`,
    welcome: 'ברוכ/ה הבא/ה',
    toUnderstand:
      'כדי להבין את מטרתו של סקר זה המבקש את זהותך והבנת פרטיות הנתונים שלך, בקר במדיניות הפרטיות של',
    privacyPol: 'OrgVitals',
    hello: 'שלום',
    answers: {
      0: 'דלג',
      1: `מאוד לא מסכים`,
      2: `קצת לא מסכים`,
      3: `לא מסכים ולא לא מסכים`,
      4: `קצת מסכים`,
      5: `מסכים לחלוטין`,
    },
    btns: {
      back: 'חזור',
      next: 'הַבָּא',
      continue: 'המשך/י',
    },
    question: {
      title: 'שְׁאֵלָה',
    },
    greeting: 'שלום! ברוכ/ה הבא/ה ל- OrgVitals.',
    descriptions:
      'OrgVitals אוספת את תגובות העובדים כדי להבין את התרבות הארגונית ועוקבת אחרי התחושות בתחומים כגון לחץ, מחוברות ותכולת תפקיד.',
    provideInfo: 'המידע שתספק/י יעזור לייצר שיח משמעותי לשיפור תרבות העבודה.',
    inputs: {
      name: {
        placeholder: 'התחל להקליד את שמך',
        label: '',
        subText: '',
        errorText: '',
      },
      email: {
        placeholder: 'אימייל',
        label: '',
        subText: '',
        errorText: '',
      },
      phone: {
        placeholder: 'טלפון',
        label: '',
        subText: '',
        errorText: '',
      },
      payrollId: {
        placeholder: 'ID',
        label: '',
        subText: '',
        errorText: '',
      },
    },
    enterCred: 'אנא הזן את האישור שלך. אם אתה רואה תפריט נפתח, אתה יכול לבחור את האישור שאתה מעדיף להשתמש בו.',
    search: 'לְחַפֵּשׂ',
    classificationFilter: (name) => `מצא את ${name} שלך:`
  },
  hmn: {
    anonymousQuestion: 'Cov lus nug tsis qhia npe',
    understandBtnText: 'Kuv to taub',
    privilegedAndConfidentialTitle: 'Koj cov lus teb rau cov lus nug yog tsis pub leej twg paub thiab tiv thaiv',
    privilegedAndConfidential: 'Tsim nyog thiab tsis pub leej twg paub: daim ntawv ntsuam xyuas no suav nrog kev ' +
        'lees paub zoo thiab kev txhim kho kev ua haujlwm-cov khoom raws li tau hais tseg thiab tiv thaiv los ntawm ' +
        '42 CFR § 483.75(o)(3), 42 USC. § 1395i-3(b)(1)(B), and 42 U.S.C. § 1396r(b)(1)(B). Daim ntawv ntsuam xyuas no,' +
        ' nws cov ntsiab lus, thiab tag nrho lwm cov ntaub ntawv, sau ntawv, sau ua ke, kev tshawb fawb, kev tshawb pom, ' +
        'cov phiaj xwm, cov lus pom zoo, kev ntsuam xyuas, kev xav, feeb, cov ntawv ceeb toom, thiab cov ntaub ntawv ' +
        'khaws cia yog qhov tsis pub lwm tus paub, muaj cai thiab tiv thaiv los ntawm tsoomfwv kev pov hwm kev noj qab ' +
        'haus huv thiab cov cai hauv lub xeev, thiab yuav tsis raug rau kev tshawb pom, kev foob lossis kev tso tawm ' +
        'rau lwm tus neeg. nkag mus rau hauv cov ntaub ntawv pov thawj hauv kev txiav txim plaub ntug, kev txiav txim' +
        ' plaub ntug, lossis lwm yam kev txiav txim plaub ntug lossis kev tswj hwm. Tsis yog yuav tsum ua pov thawj' +
        ' hais txog qhov yuav raug yuam, lossis lees txais lossis qhia rau hauv cov pov thawj, lossis hauv ib qho kev ' +
        'nqis tes ua hauv ib lub tsev hais plaub lossis ua ntej lub koom haum tswj hwm, lub koomhaum, lossis tus neeg ' +
        'rau ib lub homphiaj twg los xij. Ib qho thiab tag nrho lwm yam kev cai lij choj, kev tiv thaiv, thiab / lossis' +
        ' kev tiv thaiv tau qhia meej thiab khaws cia. ' +
        '\nKuv lees paub tias kuv tau muab kuv cov lus qhia ncaj ncees thiab tsis tau hais tawm tswv yim rau leej twg.' +
        ' Kuv pom zoo ua kom muaj kev taug qab ib ntus uas ua kom muaj kev ncaj ncees ntawm daim ntawv ntsuam xyuas no.',
    thanksForTime:
        'Ua tsaug rau koj lub sijhawm. Kev nkag siab tias cov neeg ua haujlwm xav li cas txog lawv cov kab lis kev cai ' +
        'hauv chaw ua haujlwm yog qhov tseem ceeb rau kev paub txog kev txhim kho kab lis kev cai.',
    completed: 'Koj ua tiav qhov kev ntsuam xyuas!',
    goodWork: (name) => `Ua haujlwm zoo ${name}!`,
    goToAss: 'Mus rau daim ntawv ntsuam xyuas',
    thankForResp: 'Tshooj lus no ua tiav!',
    anonymous_respond: (n) => `Koj cov lus taw qhia los ntawm kev soj ntsuam no yog tsis qhia npe, zais cia, thiab raug tiv thaiv raws li txoj cai.`,
    respond: (n) => `Thov teb cov lus nug no:`,
    welcome: 'Zoo siab txais tos',
    toUnderstand:
        'Txhawm rau nkag siab lub hom phiaj ntawm daim ntawv ntsuam xyuas no nug koj tus kheej thiab nkag siab koj cov ' +
        'ntaub ntawv ntiag tug, thov mus saib ',
    privacyPol: 'OrgVitals Txoj Cai Tswjfwm Ntiag Tug',
    hello: 'Nyob zoo',
    answers: {
      0: 'Hla',
      1: 'Tsis pom zoo',
      2: 'Me ntsis tsis pom zoo',
      3: 'Tsis pom zoo los tsis pom zoo',
      4: 'Pom zoo ib yam',
      5: 'Pom zoo heev',
    },
    btns: {
      back: 'Rov qab',
      next: 'Tom ntej no',
      continue: 'Txuas ntxiv',
    },
    question: {
      title: 'Lus nug',
    },
    greeting: 'Nyob zoo! Txais tos rau OrgVitals.',
    descriptions:
        'OrgVitals sau cov lus teb rau cov neeg ua haujlwm kom nkag siab txog kev coj noj coj ua ntawm lub koom haum ' +
        'thiab taug qab kev xav hauv thaj chaw xws li kev ntxhov siab, kev sib txuas thiab kev muaj peev xwm.',
    provideInfo:
        'Cov ntaub ntawv koj muab yuav pab tsim kev sib tham muaj txiaj ntsig los txhim kho kev ua haujlwm.',
    inputs: {
      name: {
        placeholder: 'Pib ntaus koj lub npe',
        label: '',
        subText: '',
        errorText: '',
      },
      email: {
        placeholder: 'Email',
        label: '',
        subText: '',
        errorText: '',
      },
      phone: {
        placeholder: 'Xov Tooj',
        label: '',
        subText: '',
        errorText: '',
      },
      payrollId: {
        placeholder: 'ID',
        label: '',
        subText: '',
        errorText: '',
      },
    },
    enterCred: 'Thov sau koj daim ntawv pov thawj. Yog tias koj pom qhov poob qis, koj tuaj yeem xaiv daim ntawv pov thawj uas koj nyiam siv.',
    search: 'Nrhiav',
    classificationFilter: (name) => `Nrhiav koj ${name}:`,
  },
};
